import { BookingTunnel } from "../constants/bookingSteps";

/** Resolves the booking tunnel from a pathname, or undefined outside the booking funnel. */
export const getBookingTunnel = (pathname: string): BookingTunnel | undefined => {
	if (!pathname.includes("/booking/")) {
		return undefined;
	}

	if (pathname.includes("/sdp/booking/")) {
		return "sdp";
	}

	if (pathname.includes("/stopover/booking/")) {
		return "stopover";
	}

	if (pathname.includes("/hotelonly/booking/")) {
		return "hotelonly";
	}

	return "pp";
};
